import React from 'react';

const ErrorBoundaryContext = React.createContext();

export default ErrorBoundaryContext;
